<template>
  <div  style="height: 100vh; overflow-y: scroll; -webkit-overflow-scrolling: touch">
    <!--  -->
    <img class="bancgs" @click="$router.back()" src="/static/image/bank_020021515.png" alt="">
    <iframe style="height: calc(100% - 6px); width: 100%" :src="zanzhuurl" ref="iframe" scrolling="auto" frameborder="0" id="iframe"></iframe>
  </div>
</template>
<script>
export default {
  name: 'zhanzhuye',
  data() {
    return {
      type: 1,
      zanzhuurl: '',
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    that.type = query.type;
    var baseURL = sessionStorage.getItem('baseURL') || '';
    if(that.type == 1){
      that.zanzhuurl = baseURL + '/h5/'+that.type+'.html';
    }else{
      that.zanzhuurl = baseURL + '/h5/'+that.type+'.html';
    }
  },
  methods: {},
  mounted() {
    let that = this;
  },
  updated() {},
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/zhanzhuye.vue